import { assert, assertArray, assertString } from "../utils/assertions";
import { nowIso } from "../utils/timestamps";

export const createCredentialPackageUser = ({
  userId,
  displayName,
  username,
  role,
  roles = [],
  passwordVerifier,
  status = "active",
}) => {
  assertString(userId, "credentialPackageUser.userId");
  assertString(displayName, "credentialPackageUser.displayName");
  assertString(username, "credentialPackageUser.username");
  assertString(role, "credentialPackageUser.role");
  assertArray(roles, "credentialPackageUser.roles");
  assertString(passwordVerifier, "credentialPackageUser.passwordVerifier");
  assertString(status, "credentialPackageUser.status");

  return {
    userId,
    displayName,
    username,
    role,
    roles,
    passwordVerifier,
    status,
  };
};

export const createCredentialPackage = ({
  id,
  vesselId,
  version,
  issuedAt = nowIso(),
  activatedAt = issuedAt,
  syncedAt = issuedAt,
  isActive = true,
  users = [],
}) => {
  assertString(id, "credentialPackage.id");
  assertString(vesselId, "credentialPackage.vesselId");
  assert(typeof version === "number", "credentialPackage.version must be a number");
  assertArray(users, "credentialPackage.users");

  return {
    id,
    vesselId,
    version,
    issuedAt,
    activatedAt,
    syncedAt,
    isActive,
    users: users.map(createCredentialPackageUser),
  };
};
